import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from 'ionic-angular';
import { NavSidebarOutOfSyncWarning } from './nav-sidebar-out-of-sync';
import { TooltipDirectiveModule } from '../../../../directives/tooltip/index.module';

@NgModule({
    declarations: [NavSidebarOutOfSyncWarning],
    imports: [CommonModule, IonicModule, TooltipDirectiveModule],
    exports: [NavSidebarOutOfSyncWarning]
})
export class NavSidebarOutOfSyncWarningModule {}



// WEBPACK FOOTER //
// ./src/components/core/nav-sidebar/out-of-sync-warning/nav-sidebar-out-of-sync.module.ts